<!--键盘-->
<template>
<!--    <div>-->
        <div class="pay-tool-keyboard">
            <ul>
                <li @click="keyUpHandle($event)" v-for="(val, index) in keys" :key="index" :style="style">
                    {{ val }}
                </li>
                <li class="del" @click="delHandle" :style="style">
<!--                    <img class="icon-del" :src="$util.imgSrc('before/delete')" />-->
                </li>
            </ul>
        </div>
<!--    </div>-->
</template>

<script>
export default {
    name: "KeyBoard",
    props: {
        keyBoardObj:{
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    data(){
        return {
            curIndex:'',
            password:[],
            keys:[],
            style:{}
        }
    },
    mounted () {
        if (document.documentElement.clientHeight <= 650) {
            this.style = {  height: "3.2rem",lineHeight: "3.2rem" }
        }
        this.onMounted();
    },

    created(){
        this.keys = this.getKeys();
    },
    watch:{
        "keyBoardObj.curIndex":function(val){
            if(val){
                this.curIndex = val;
            }
        },
        "keyBoardObj.password":function(val){
            if(val){
                this.password = val;
            }
        },
        "keyBoardObj.layout":function(){
            if(!this.keyBoardObj.isRandom) return;
            this.keys = this.getKeys();
        }
    },
    methods: {
        onMounted(){
            this.curIndex = this.keyBoardObj.curIndex;
            this.password = this.keyBoardObj.password;
        },
        getKeys:function(){
            const numLists = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
            if(this.keyBoardObj.isRandom){
                const randomSort = () => Math.random() > .5 ? -1 : 1;
                numLists.sort(randomSort);
            }
            let btnText = this.keyBoardObj.isConfirm ? "确认" : "";
            numLists.splice(9,0,btnText);
            return numLists;
        },
        keyUpHandle(e) {
            let text = e.currentTarget.innerText
            if( text.indexOf("确认") !== -1) {
                this.$parent.isShow = false;
                return;
            }
            let len = this.password.length
            if (!text || len >= 6) return
            this.password.push(text);
            this.curIndex = len;
            this.triggleData();
        },
        delHandle() {
            if (this.password.length <= 0) return false
            this.password.pop();
            this.curIndex--;
            this.triggleData();
        },
        clearPasswordHandle() {
            this.password = [];
            this.curIndex = -1;
            this.triggleData();
        },
        triggleData(){
            this.$emit("pwd-get",{password:this.password,curIndex:this.curIndex});
        }
    }
};
</script>

<style lang="scss">
    .pay-tool-keyboard {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 1rem 0;
        background: #CECFD3;
        ul {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            li {
                width: calc((100% - 2.4rem)/3);
                height: 4.5rem;
                line-height: 4.5rem;
                text-align: center;
                background: #fff;
                font-size: 2rem!important;
                font-weight: bold;
                border: 1px solid #cecece;
                border-radius: 4px;
                box-shadow: 1px 0 3px #999;
                margin: 0.3rem;
                &:nth-child(1), &:nth-child(2), &:nth-child(3) {
                    border-top: 1px solid #eee;
                }
                &:nth-child(3), &:nth-child(6), &:nth-child(9), &:nth-child(12) {
                    border-right: none;
                }
                &:nth-child(10), &:nth-child(11), &:nth-child(12) {
                    border-bottom: none;
                }
                &:nth-child(10), &:nth-child(12) {
                    background-color: #CECFD3;
                    box-shadow: none;
                }
                &:nth-child(12):active {
                    background-color: #fff;
                }
                .icon-del{
                    width: 2.4rem;
                    height: 1.7rem;
                }
            }
        }
    }
</style>
